export default {
  payoutRequestsListState(context) {
    return context.list || [];
  },
  arePayoutRequestsLoaded(context) {
    return Boolean(context.list);
  },
  createLoadingState(context) {
    return context.createLoading;
  }
};
